<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.value"
            :error-messages="valueErrors"
            :label="$t('global.value')"
            required
            @input="$v.item.value.$touch()"
            @blur="$v.item.value.$touch()"
          />
        </v-col>
      </v-row>


    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';

export default {
  name: 'ProductDataForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        name: null,
        value: null,

    };
  },
  computed: {
    isLoading() {
      return (false
       );
    },

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    valueErrors() {
      const errors = [];

      if (!this.$v.item.value.$dirty) return errors;

      has(this.violations, 'value') && errors.push(this.violations.value);

      !this.$v.item.value.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {

  },
  validations: {
    item: {
      name: {
        required,
      },
      value: {
        required,
      },
    }
  }
};
</script>
